import styled from 'styled-components'

export default styled.h4`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  letter-spacing: -0.03em;
  color: #363636;
  margin-bottom: 2px;
`
